import axios from 'axios';

export async function init() {

}

export async function getPageInsights({ commit, state }) {
	commit('SET_LOADING', true);

	const { data } = await axios.get('/metrics/page', {
		params: {
			range: state.selectedRange,
		},
	});
	commit('SET_PAGE_INSIGHTS', data);

	commit('SET_LOADING', false);
}
